var app = angular.module('directives.banner');


    app.directive('moveBanner',["$interval","$state","$timeout", function($interval,$state,$timeout){
  return {
    link: function(scope, element, attrs) {
      $(element[0]).slick({
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 10000,
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        accessibility: true,
        useTransform: true
      });
      
      $('.slick-dots').wrapAll('<div class="banner-dots container">');
      
      $(element[0]).on('afterChange', function(event, slick, currentSlide) {
        $(this).find('.slick-dots button').attr('aria-selected', 'false');
        $(this).find('.slick-dots .slick-active button').attr('aria-selected', 'true');
        $(this).find('.slick-dots button').attr('tabindex', '0');
        
        var totalSlides = slick.slideCount;
        var currentSlideNumber = currentSlide + 1;
        var statusMessage = 'Слайд ' + currentSlideNumber + ' з ' + totalSlides;
        $(this).find('.slider-status').text(statusMessage);
      });
      
      setTimeout(function() {
        var $container = $(element[0]);
        var $dots = $container.find('.slick-dots');
        var $bannerDots = $container.find('.banner-dots');
        
        $bannerDots.removeAttr('role');
        
        $dots.attr('role', 'tablist').attr('aria-label', 'Навігація по слайдах каруселі');
        
        $dots.find('li').each(function(index) {
          var $li = $(this);
          var $button = $li.find('button');
          var isActive = $li.hasClass('slick-active');
          var slideNumber = index + 1;
          
          $li.removeAttr('role');
          
          // Отримуємо мову для локалізації
          var currentLang = 'ua';
          try {
            if (localStorage) {
              currentLang = localStorage.getItem('lang') || 'ua';
            }
          } catch(e) {}
          
          // Формуємо aria-label в залежності від мови
          var ariaLabel = '';
          if (currentLang === 'en') {
            ariaLabel = 'Slide #' + slideNumber;
          } else {
            ariaLabel = 'Слайд №' + slideNumber;
          }
          
          $button.attr({
            'role': 'tab',
            'aria-selected': isActive ? 'true' : 'false',
            'aria-controls': 'slide-' + index,
            'id': 'tab-slide-' + index,
            'aria-label': ariaLabel
          });
          
          $button.removeAttr('aria-hidden');
          if ($button.attr('role') === 'button') {
            $button.removeAttr('role');
          }
          
          $button.attr('tabindex', '0');
        });
        
        $container.find('.slick-slide').each(function(index) {
          $(this).attr({
            'role': 'tabpanel',
            'aria-labelledby': 'tab-slide-' + index,
            'id': 'slide-' + index
          });
        });
        
        $container.find('.slick-track[role="listbox"]').attr('role', 'region').attr('aria-label', 'Карусель рекламних пропозицій');
        $container.find('.slick-slide[role="option"]').removeAttr('role');
        
        $container.removeAttr('aria-live');
        $container.find('[aria-live]').removeAttr('aria-live');
        
        if (!$container.find('.slider-status').length) {
          $container.append('<div class="slider-status" role="status" aria-live="polite" aria-atomic="true" style="position: absolute; left: -10000px; width: 1px; height: 1px; overflow: hidden;"></div>');
        }
        
        $container.find('.slick-dots button').attr('tabindex', '0');
        
        $container.find('[aria-hidden="true"] [tabindex="0"], [aria-hidden="true"] button, [aria-hidden="true"] a').attr('tabindex', '-1');
        
        setInterval(function() {
          $container.find('.slick-dots button[tabindex="-1"]').attr('tabindex', '0');
        }, 500);
        
        var totalSlides = $container.find('.slick-slide').length;
        if (totalSlides > 0) {
          $container.find('.slider-status').text('Слайд 1 з ' + totalSlides);
        }
      }, 100);
    }
  }
    }]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/main.baner/directives/direct.js
 ** module id = 178
 ** module chunks = 1
 **/